import { citadine15000 } from './citadine15000';
import { financements } from './financements';
import { motorisations } from './motorisations';
import { occasionChecks } from './occasionChecks';
import { suv30000 } from './suv30000';
import { hybrideRechargeableSansRecharge } from './hybrideRechargeableSansRecharge';
import { comparerDeuxOccasions } from './comparerDeuxOccasions';
import { voitureFamilleDeuxEnfants } from './voitureFamilleDeuxEnfants';

export const articles = [
  citadine15000,
  suv30000,
  motorisations,
  financements,
  occasionChecks,
  hybrideRechargeableSansRecharge,
  comparerDeuxOccasions,
  voitureFamilleDeuxEnfants,
];

export const articlesBySlug = new Map(articles.map((article) => [article.slug, article]));

export const articlePath = (slug: string) => `/conseils/${slug}/`;
